import { isSet } from "../utils/isSet";

export const addDotBtnsAndClickHandlers = (emblaApi, dotsNode) => {
  	let dotNodes = [];

	const addDotBtnsWithClickHandlers = () => {
		dotsNode.innerHTML = emblaApi
			.scrollSnapList()
			.map(() => '<button class="embla__dot" type="button"></button>')
			.join('')

		dotNodes = Array.from(dotsNode.querySelectorAll(".embla__dot"));
		dotNodes.forEach((dotNode, index) => {
			dotNode.addEventListener(
                "click", function(){
                    emblaApi.scrollTo(index)
                }, false
            );
		});
	};

	const toggleDotBtnsActive = () => {
		const previous = emblaApi.previousScrollSnap();
		const selected = emblaApi.selectedScrollSnap();

		if(isSet(dotNodes[previous])) dotNodes[previous].classList.remove("embla__dot--selected");
		if(isSet(dotNodes[selected])) dotNodes[selected].classList.add("embla__dot--selected");
	};

	emblaApi
		.on("init", addDotBtnsWithClickHandlers)
		.on("reInit", addDotBtnsWithClickHandlers)
		.on("init", toggleDotBtnsActive)
		.on("reInit", toggleDotBtnsActive)
		.on("select", toggleDotBtnsActive);

	return () => {
		dotsNode.innerHTML = "";
	};
};
